
import { mapState } from 'vuex'
import HeroButton from '@/components/HeroButton'
import InfoIcon from '@/static/svg/prescription/info-icon.svg'
import ProductPrescriptionOptionSelector from '@/components/ProductPrescriptionOptionSelector'
import LoadingSpinner from '@/components/LoadingSpinner'

export default {
  components: {
    HeroButton,
    ProductPrescriptionOptionSelector,
    InfoIcon,
    LoadingSpinner,
  },
  props: {
    productId: {
      type: Number,
      default: null,
    },
    itemSelectedOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      baseColumn: {
        name: 'lineItem',
        id: 'item',
      },
      productDataRetrieved: false,
    }
  },
  computed: {
    ...mapState(['loading', 'product', 'prescription']),
    ...mapState({
      stock: (state) => ({
        isLoading: !!state.loading.lineItem,
        error: state.errors.lineItem,
        stock: state.stock.lineItemStock?.stock,
        limited: state.stock.lineItemStock?.limited,
      }),
    }),
    columns() {
      const column = { ...this.baseColumn }
      column.isSelected = true
      column.selectedOptions = this.prescription.lineItemOptions
      column.errors = {}
      return [column]
    },
    isSkuInvalid() {
      return !!this.stock.error
    },
    showWarning() {
      return this.isSkuInvalid || this.hasLimitedStock
    },
    disabled() {
      return this.isSkuInvalid || this.hasLimitedStock
    },
    hasLimitedStock() {
      const { limited, stock } = this.stock
      return !!(limited && stock === 0)
    },
    isLoading() {
      return !!this.loading.product
    },
  },
  async created() {
    this.$store.dispatch('product/setProductId', this.productId)
    await this.$store.dispatch('product/getProduct')
    this.$store.dispatch('stock/resetLineItemStockData')
    this.itemSelectedOptions.forEach((selectedOption) => {
      const fullOptionData = this.product.options.find((option) => {
        return selectedOption.type === option.name
      })

      const option = {
        name: selectedOption.type,
        type: fullOptionData.type,
        label: selectedOption.value,
        value: selectedOption.id,
      }

      this.$store.dispatch('prescription/setLineItemOption', option)
    })
    this.productDataRetrieved = true
  },
  methods: {
    async selectOption(event) {
      this.$store.dispatch('prescription/setLineItemOption', event.option)
      await this.$store.dispatch('stock/getLineItemStock')
    },
    itemOptionsUpdated() {
      const updatedOptions = this.product.options.map((option) => {
        const { value, label } = this.prescription.lineItemOptions[option.name]

        return {
          id: value,
          type: option.name,
          value: label,
        }
      })
      this.$emit('item-options-updated', updatedOptions)
    },
    itemOptionsEditCancelled() {
      this.$emit('cancel-edit-item-options')
    },
  },
}
